import { render, staticRenderFns } from "./AllClassify.vue?vue&type=template&id=65aa816b&scoped=true"
import script from "./AllClassify.vue?vue&type=script&lang=js"
export * from "./AllClassify.vue?vue&type=script&lang=js"
import style0 from "./AllClassify.vue?vue&type=style&index=0&id=65aa816b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa816b",
  null
  
)

export default component.exports